export const paperSx = { p: 2 } as const;
export const fieldsSx = { '& > *': { mb: 2 } } as const;
export const buttonBarSx = { display: 'flex', justifyContent: 'flex-end', '& > *': { m: 1, mr: 0 } } as const;
